export enum OutstandingChallengeType {
  submissions = 'submissions',
  reviews = 'reviews',
}
